import { operateMaxShowLength } from '@/store/dict/config'

export const STATE_MAP = {
  2: '查询中',
  3: '查询完成',
  4: '查询失败',
}
export const LOGIN_METHOD = {
  USER_NAME_PASSWORD: 1, // 账密登录
  QR_CODE: 2, // 扫码登录
}
export const LOGIN_METHOD_2_TEXT = {
  [LOGIN_METHOD.USER_NAME_PASSWORD]: '账密登录',
  [LOGIN_METHOD.QR_CODE]: '扫码登录',
}

const isContractCar = (row) => row.operateType && ['3', '5', '8'].includes(String(row.operateType))

export default function () {
  const headData = [
    {
      name: 'account',
      columnProps: {
        prop: 'account',
        label: '账号ID',
      },
    },
    {
      name: 'city',
      columnProps: {
        prop: 'city',
        label: '城市',
      },
    },
    {
      name: 'domain',
      columnProps: {
        prop: 'domain',
        label: '查询网址',
      },
    },
    {
      name: 'loginMethod',
      columnProps: {
        prop: 'loginMethod',
        label: '登录方式',
      },
      getText: ({ row: { loginMethod } }) => LOGIN_METHOD_2_TEXT[Number(loginMethod)] || '--',
    },
    {
      name: 'needUdun',
      columnProps: {
        prop: 'needUdun',
        label: '是否需要U盾',
        width: '150px',
      },
      getText: ({ row }) => {
        if (row.loginMethod === LOGIN_METHOD.QR_CODE) {
          return '--'
        }
        return Number(row.needUdun) === 1 ? '是' : '否'
      },
    },
    {
      name: 'open',
      columnProps: {
        prop: 'open',
        label: '定时查询',
      },
      getText: ({ row }) => {
        if (row.needUdun === 1) {
          return '停用'
        } else {
          return row.open === 1 ? '启用' : '停用'
        }
      },
    },
    {
      name: 'taskState',
      columnProps: {
        prop: 'taskState',
        label: '查询状态',
      },
      getText: ({ row }) => STATE_MAP[row.taskState],
    },
    {
      name: 'lastTaskTime',
      columnProps: {
        prop: 'lastTaskTime',
        label: '最后一次查询完成时间',
        width: '200px',
      },
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        width: 240,
        fixed: 'right',
      },
      maxShowLength: operateMaxShowLength,
      getOperateList: ({ row }) => {
        const optBtns = []
        if (this.judgePermission('vehicle_violation_account_edit')) {
          optBtns.push({
            name: 'edit',
            label: '编辑',
            action: () => this.editAccount(row),
          })
        }
        if (this.judgePermission('vehicle_violation_account_query')) {
          optBtns.push({
            name: 'query',
            label: '查询',
            action: () => this.queryAccount(row),
          })
        }
        if (this.judgePermission('vehicle_violation_query_record')) {
          optBtns.push({
            name: 'recordList',
            label: '查看记录',
            action: () => this.recordList(row),
          })
        }

        // 只有账密登录，且不使用U盾的账号才能启用停用
        const canStartStop = row.loginMethod === LOGIN_METHOD.USER_NAME_PASSWORD
           && row.needUdun === 0
        if (canStartStop && this.judgePermission('vehicle_violation_account_enable')) {
          const statusText = row.open === 1 ? '停用' : '启用'
          optBtns.push({
            name: 'status',
            label: statusText,
            action: () => this.changeStatus(row),
          })
        }
        return optBtns
      },
      type: 'operate',
    },
  ]
  const queryRecordHeadData = [
    {
      name: 'queryTime',
      columnProps: {
        prop: 'queryTime',
        label: '查询时间',
      },
    },
    {
      name: 'corporateName',
      columnProps: {
        prop: 'corporateName',
        label: '公户单位名称',
      },
    },
    {
      name: 'vehicleCount',
      columnProps: {
        prop: 'vehicleCount',
        label: '查询车辆总数',
      },
      getText: ({ row }) => (isContractCar(row) ? '--' : row.vehicleCount),
    },
    {
      name: 'successCount',
      columnProps: {
        prop: 'successCount',
        label: '查询成功车辆数',
      },
      getText: ({ row }) => (isContractCar(row) ? '--' : row.successCount),
    },
    {
      name: 'contractCarCount',
      columnProps: {
        prop: 'contractCarCount',
        label: '同显车辆数',
      },
      getText: ({ row }) => (isContractCar(row) ? '--' : row.contractCarCount),
    },
    {
      name: 'failCount',
      columnProps: {
        prop: 'failCount',
        label: '查询失败车辆数',
      },
      getText: ({ row }) => (isContractCar(row) ? '--' : row.failCount),
    },
    {
      name: 'addCount',
      columnProps: {
        prop: 'addCount',
        label: '本次新增违章车辆数',
      },
      getText: ({ row }) => (isContractCar(row) ? '--' : row.addCount),
    },
    {
      name: 'addRecordCount',
      columnProps: {
        prop: 'addRecordCount',
        label: '本次新增违章条数',
      },
      getText: ({ row }) => (isContractCar(row) ? '--' : row.addRecordCount),
    },
    {
      name: 'contractEffectCount',
      columnProps: {
        prop: 'contractEffectCount',
        label: '违章同显生效数',
      },
      getText: ({ row }) => (isContractCar(row) ? '--' : row.contractEffectCount),
    },
    {
      name: 'operateTypeName',
      columnProps: {
        prop: 'operateTypeName',
        label: '操作类型',
      },
    },
    {
      name: 'stateName',
      columnProps: {
        prop: 'stateName',
        label: '查询状态',
      },
    },
    {
      name: 'operator',
      columnProps: {
        prop: 'operator',
        label: '操作人',
      },
    },
    {
      name: 'queryErrorDesc',
      columnProps: {
        prop: 'queryErrorDesc',
        label: '错误说明',
      },
    },
  ]
  return { headData, queryRecordHeadData }
}
